import BaseModel from './BaseModel';

export class PolicyholderActivityModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.last_login = data.last_login || null;
    this.total_logins = data.total_logins || 0;
    this.requests_submitted = data.requests_submitted || 0;
    this.work_orders_open = data.work_orders_open || 0;
    this.work_orders_overdue = data.work_orders_overdue || 0;
    this.work_orders_closed = data.work_orders_closed || 0;
  }
}

export class PolicyholderActivityStatsModel extends BaseModel {
  init(data) {
    this.total_logins = data.total_logins || 0;
    this.requests_submitted = data.requests_submitted || 0;
    this.work_orders_closed = data.work_orders_closed || 0;
  }
}
